goog.require('el8.template.multiuser_access.passwordReset');
goog.require('el8.shared.util.passwordHelp');
goog.require('el8.service.urls');
goog.require('el8.util.base');
goog.require('el8.uiwidget.Form');

var el8 = el8 || {};
if(!el8.multiuser_access) { el8.multiuser_access = {}; }

el8.multiuser_access.passwordReset = (function() {

    var that = {};

    var userProfileId = null;
    var faxCode = null;
    var theForm = null;
    var passwordResetToken = null;
    var passwordHelp = null;

    function submitNewPassword() {
        // submit the answer to the server
        var password1 = theForm.getVal('password1');
        var password2 = theForm.getVal('password2');

        if (!(password1 && password1 === password2 && passwordHelp.passwordCheck1(password1) && passwordHelp.passwordCheck2(password1))) {
            return;
        }



        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('submitNewPassword', [faxCode, userProfileId, passwordResetToken]),
            data: JSON.stringify({
                password1: password1,
                password2: password2
            }),
            async: true,
            success: function(data) {
                if (data.location) {
                    location.href=data.location;
                } else {
                    location.href='/efax/error/';
                }
            }
        });
    }

    function inputChanged() {
        var password1 = theForm.getVal('password1');
        var password2 = theForm.getVal('password2');

        if (password1 && password1 === password2 && passwordHelp.passwordCheck1(password1) && passwordHelp.passwordCheck2(password1)) {
            $('#go-to-chart').prop('disabled', false);
        } else {
            $('#go-to-chart').prop('disabled', true);
        }
    }

    var debouncedInputChanged = _.debounce(inputChanged, 250);

    function setupKeyPressedListeners() {
        $(document).on('keypress', ':input[name="password1"], :input[name="password2"]', debouncedInputChanged);
    }

    that.init = function(spec) {
        /**
         * Initialize the global URL service
         */

        if (spec.urls) { el8.service.urls.init(spec.urls); }

        userProfileId = spec.userProfileId;
        faxCode = spec.faxCode;
        passwordResetToken = spec.passwordResetToken;

        $('.main-content').html(
            el8.template.multiuser_access.passwordReset.content({})
        );

        theForm = new el8.uiwidget.Form({
            fields: [{
                name: 'password1',
                selector: ':input[name="password1"]',
                maxLength: 12,
                changeFn: function() {
                    inputChanged();
                }
            },
            {
                name: 'password2',
                selector: ':input[name="password2"]',
                maxLength: 12,
                changeFn: function() {
                    inputChanged();
                }
            }],
            container: $('#main-form')
        });
        theForm.render();

        passwordHelp = el8.shared.util.passwordHelp;
        passwordHelp.init(theForm);
        passwordHelp.setupPasswordHelp();

        inputChanged();

        $(':input[name="password1"]').focus();

        setupKeyPressedListeners();
        $(document).on('click', '#go-to-chart', function(event) {
            submitNewPassword();
        });
    };

    return that;

})();